import { TemplateCodeParameter } from "../../ars_ldm";
import { ArsTableGroupCalculationDto } from "../interface";

/**
 * Collects entries that store parameters for the requested value source.
 *
 * @param group - Table entry whose matching descendants are collected.
 * @param path - JSON Pointer path to the table entry.
 * @param valueSource - Parameter source identifying operations or grouping factors.
 * @returns JSON Pointer paths for entries with the requested parameter source.
 */
export const collectParameterPaths = <T>(
  group: ArsTableGroupCalculationDto<T>,
  path: string,
  valueSource: TemplateCodeParameter["valueSource"],
): string[] => [
  ...((valueSource === "operation" ? "operationId" : "groupingFactorId") in group ? [path] : []),
  ...(group.subGroups?.flatMap((child, index) =>
    collectParameterPaths(child, `${path}/subGroups/${index}`, valueSource),
  ) ?? []),
];
